import {Body1, Box, Button, Chip, styled, Subtitle2, CollectionsOutlinedIcon, Heading6, Body2, Tooltip} from '../../../ui-library';
import {TextFieldVI} from '../../TextFieldVI';
import {tooltipClasses} from '@mui/material';
import React from 'react';


export const ModalBox = styled(Box)`
    display: flex;
    flex-direction: column;
    position: absolute;
    width: 600px;
    flex-wrap: wrap;
    left: calc(50% - 600px/2);
    top: calc(35% - 387px/3);
    background: #FFFFFF;
    border-radius: 10px;
    padding: 16px 8px 8px 24px;
`;

export const TitlesDataBox = styled(Box)`
    display: flex;
    flex-direction: column;
    gap: 18px;
    padding-right: 16px;
`;

export const ContentClassesBox = styled(Box)`
    display: flex;
    flex-direction: column;
    gap: 11px;
`;

export const ModalTitle = styled(Heading6)`

`;

export const LabelTitle = styled(Body1)`
    padding-top: 8px;
`;

export const BoldLabelTitle = styled(Body1)`
    padding-top: 8px;
    font-weight: bold;
`;

export const ContentTitle = styled(Body2)`
    color: ${({ theme }) => theme.palette.grey[700]};

`;

export const StyledTextFieldVI = styled(TextFieldVI)`
`;


export const ClassChip = styled(Chip)`
    margin-top: 11px;
    margin-bottom: 13px;
    height: 24px;
    & .MuiChip-label{
        font-weight: 500;
        font-size: 12px;
        line-height: 18px;
        letter-spacing: 0.16px;
  }
`;

export const InTrainClassChip = styled(ClassChip)`
    background-color: ${({ theme }) => theme.palette.grey[200]};
    & .MuiChip-label{
        color: ${({ theme }) => theme.palette.grey[500]};
  }
`;

export const OutTrainClassChip = styled(ClassChip)`
    margin-right: 11px;
    background-color: ${({ theme }) => theme.palette.error.light};
    & .MuiChip-label{
        color: ${({ theme }) => theme.palette.error.dark};
  }
`;

export const ClassesBox = styled(Box)`
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    align-items: center;
    max-width: 519px;
`;

export const ClassContainer = styled(Box)`
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    align-items: center;
    gap: 6px;
`;


export const ImagesIcon = styled(CollectionsOutlinedIcon)`
    margin-top: 11px;
    margin-bottom: 13px;
    color : ${({ theme }) => theme.palette.grey['600']};
    font-size: 16px;

`;

export const NumOfImages = styled(Subtitle2)`
    margin-top: 11px;
    margin-bottom: 13px;
    color: ${({ theme }) => theme.palette.grey['800']};
    padding-right: 16px;
`;

export const CancelBtn = styled(Button)`
    ${({ theme }) => theme.typography.button};
    font-size: 14px;
    align-items: center;
`;

export const StartBtn = styled(Button)`
    ${({ theme }) => theme.typography.button};
    font-size: 14px;
    align-items: center;
`;

export const ButtonsBox = styled(Box)`
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: flex-start;
    padding-top: 24px;
    gap: 6px;
`;

export const CustomTooltip = styled(({ className, ...props }: any) => (
    <Tooltip {...props} classes={{ popper: className }} />
// eslint-disable-next-line @typescript-eslint/no-unused-vars
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: 'rgba(17, 24, 39, 0.9)',
    },
}));
